// extracted by mini-css-extract-plugin
export default {"image":"SuccessModal_image__JLD7p"};